"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEST_PROJECT_DESCRIPTION = exports.SYSTEM_PROJECT_SLUG = exports.PUBLIC_PROJECT_SLUG = void 0;
exports.PUBLIC_PROJECT_SLUG = 'PUBLIC';
exports.SYSTEM_PROJECT_SLUG = 'SYSTEM';
exports.TEST_PROJECT_DESCRIPTION = 'TEST';
